import { ForwarderCooperationRequest } from './../pages/forwarder-cooperation/interface/forwarder-cooperation-request';
import { ForwarderCooperationResponse } from './../pages/forwarder-cooperation/interface/forwarder-cooperation-response';
import { PageResp } from './../../../core/models/page/page-response';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ForwarderCooperationService {
  private messageSource = new Subject<any>();
  message$ = this.messageSource.asObservable();

  constructor(private http: HttpClient) { }

  setMessage(msg: any) {
    this.messageSource.next(msg);
  }

  searchForwarderCoopearation(request: ForwarderCooperationRequest): Observable<PageResp<ForwarderCooperationResponse>>{
    const url = `${environment.expenseApiUrl}/import/searchForwarderAndCooperation`;
    return this.http.post<PageResp<ForwarderCooperationResponse>>(url, request);
  }

  getForwarderList(): Observable<any>{
    const url = `${environment.logisticsApiUrl}/forwarder`;
    return this.http.get(url);
  }
}
